import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import type { SlideState } from "../../types.d";
import type { SlideViewMode } from "../slide/slide";

@customElement("bp-paragraph-slide")
export class ParagraphSlide extends LitElement {
  static styles = css`
    .caption {
      color: var(--color-gray);
      font-size: var(--font-size-xl);
      margin-top: var(--size-3);
    }

    sup {
      color: var(--color-black);
      font-size: var(--font-size-xl);
      vertical-align: 9px;
      font-weight: var(--font-weight-semibold);
    }

    ol {
      margin-left: var(--size-2);
    }
  `;

  @property()
  slideState?: SlideState;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  @property({ attribute: "title" })
  slideTitle?: string;

  @property({ attribute: "content" })
  content?: string;

  @property({ attribute: "caption" })
  caption?: string;

  render() {
    return html`
      <bp-scrollable-slide
        view-mode="${this.viewMode}"
        .slideState=${this.slideState}
      >
        <div slot="title">${unsafeHTML(this.slideTitle)}</div>
        <div slot="content">
          ${unsafeHTML(this.content)}
          ${this.caption
            ? html`<div class="caption">${unsafeHTML(this.caption)}</div>`
            : ""}
        </div>
      </bp-scrollable-slide>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-paragraph-slide": ParagraphSlide;
  }
}
